import { Action } from '@portfolio/models'
import React, { FC, ReactElement } from 'react'
import { captureException } from '@sentry/nextjs'
import { KlaviyoFormModal } from '../KlaviyoForm/KlaviyoFormModal'
import { ContactFormModal } from '../ContactForm/ContactFormModal'

type LinkActionProps = {
  action: Action
  className?: string
  renderTrigger: (action: { click: () => void }) => ReactElement
}

export const LinkAction: FC<LinkActionProps> = ({ action, renderTrigger }) => {
  switch (action.type) {
    case 'klaviyoFormModal': {
      return (
        <KlaviyoFormModal
          formId={action.payload?.formId}
          renderTrigger={renderTrigger}
        />
      )
    }
    case 'contactFormModal': {
      return (
        <ContactFormModal
          socials={action.payload.socials}
          crmContext={action.payload.crmContext}
          contactForm={action.payload.contactForm}
          renderTrigger={renderTrigger}
        />
      )
    }
    default:
      captureException(
        new Error(
          `[LinkAction] There is no defined actionType${
            (action as Action)?.type && `: ${(action as Action).type}`
          }`,
        ),
      )
      return <h3>There is no defined actionType.</h3>
  }
}
